import type { CalendarEventReminder } from "../Models/Domain";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { createReminder } from "@/Services/TherapyApi/Calendars";
import CalendarEventReminderTransformer from "@/Modules/Transformers/Calendars/EventReminder";

import useCalendarsStore from "../Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

const createCalendarEventReminder = async (
  reminder: Omit<CalendarEventReminder, "uuid">
): Promise<CalendarEventReminder | undefined> => {
  const calendarsStore = useCalendarsStore();
  const appStore = useAppStore();
  let eventReminder: CalendarEventReminder | undefined = undefined;

  try {
    const eventReminderApi = await createReminder(
      CalendarEventReminderTransformer.toApi(reminder as CalendarEventReminder)
    );

    eventReminder = CalendarEventReminderTransformer.toDomain(eventReminderApi);
    calendarsStore.config?.reminders.push(eventReminder);

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "calendars.menu.config.advice_policy.save_success",
    });
  } catch (e) {
    danger("Error updating config", e);

    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "calendars.menu.config.advice_policy.save_error",
    });
  }
  return eventReminder;
};

export default createCalendarEventReminder;
